
import { useState, useRef } from 'react';
import '../styles/icon.scss'


const scaleCoords = ({ coords = [], imgWidth, naturalWidth }) => {
  return coords.map(coord => coord * (imgWidth / naturalWidth))
};

const imageDimensions = file =>
  new Promise((resolve, reject) => {

    if (!file) {
      resolve({ height: 0, width: 0 })
    }
    const img = new Image()
    // the following handler will fire after a successful loading of the image
    img.onload = () => {
      const { naturalWidth: width, naturalHeight: height } = img
      resolve({ width, height })
    }
    // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
    img.onerror = () => {
      reject('There was some problem with the image.')
    }

    img.src = file
  })

const Icon = ({ 
    coords = [], 
    imgWidth, 
    img = '' ,
    content,
    tintWindow,
    toggleModal
  }) => {
  const [width, setWidth] = useState(0)
  const timeoutRef = useRef(null);

  imageDimensions(img).then(res => setWidth(res.width))

  const newCoords = scaleCoords({ coords, imgWidth, naturalWidth: width })

  const icon = (type) => {
console.log(content)
    switch(type) {
      case 'video--speaker':
        return (
          <>
            <i className="icon__svg icon__svg--speaker"></i>
            <div className="para icon__title icon__title--yellow">{content.title}</div>
          </>
        )
      case 'video--warning':
        return (
          <>
            <i className="icon__svg icon__svg--warning"></i>
            <div className="para icon__title icon__title--yellow">{content.title}</div>
          </>
        )
      case 'url--recycling':
        return (
          <>
            <i className="icon__svg icon__svg--recycling"></i>
            <div className="para icon__title icon__title--yellow">{content.title}</div>
          </>
        )
      case 'url--visit':
        return (
          <>
            <i className="icon__svg icon__svg--visit"></i>
            <div className="para icon__title icon__title--yellow">{content.title}</div>
          </>
        )
      case 'url--download':
        return (
          <>
            <i className="icon__svg icon__svg--download"></i>
            <div className="para icon__title icon__title--yellow">{content.title}</div>
          </>
        )
      case 'url--store':
        return (
          <>
            <i className="icon__svg icon__svg--store"></i>
            <div className="para icon__title icon__title--yellow">{content.title}</div>
          </>
        )
      default:
        return (
          <>
            <div className="para icon__number">{content.id}</div>
            <div className="para icon__title">{content.title}&nbsp;</div>
          </>
        )
    }
  }

  return (
    width ?
      <button
        className={ `icon ${content.type} ${content.open_reverse ? 'icon--open-reverse' : ''}`}
        style={{
          top: newCoords[1],
          left: newCoords[0],
        }}
        onMouseEnter={(e) => {
          if(timeoutRef.current){
            clearTimeout(timeoutRef.current)
          }
          document.querySelectorAll(".icon").forEach((icon)=> {
            icon.style.zIndex = 9
            icon.style.opacity = 0.7
          })
          e.target.style.zIndex = 10
          e.target.style.opacity = 1

          tintWindow({scaledCoords: scaleCoords({ coords: content.coords, imgWidth, naturalWidth: width })})}
        }
        onMouseLeave={()=> {
          const canvas = document.getElementsByClassName('img-mapper-canvas')[0]
          canvas.classList.remove("opacity--in")

          timeoutRef.current = setTimeout(() => {
            canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
          }, 100)

          document.querySelectorAll(".icon").forEach((icon)=> {
            icon.style.opacity = 1
          })
        }}
        onClick={()=>{
          if (content.type === "url--recycling" || content.type === "url--visit" || content.type === "url--download" || content.type === "url--store") {
            window.open(content.url);
          } else {
            toggleModal(content)
          }
        }}
      >
        {icon(content.type)}
      </button>
      :
      null
  )
}

export default Icon
